// src/redux/reducer.js
import { SET_SELECTED_TAB } from "../ActionTypes/index";

const initialState = {
  selectedTab: "TWG",
};

const tabReducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_SELECTED_TAB:
      return {
        ...state,
        selectedTab: action.payload,
      };
    default:
      return state;
  }
};

export default tabReducer;
